import { render, staticRenderFns } from "./userChart.vue?vue&type=template&id=f58c5414&"
import script from "./userChart.vue?vue&type=script&lang=js&"
export * from "./userChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports